import React, { HTMLAttributes } from 'react';

import {
  Accordion as ReactAccordion,
  AccordionItem as ReactAccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
  AccordionItemState,
} from 'react-accessible-accordion';

import './style.scss';
import Icon, { IconTypes } from '../Icon/Icon';

export interface AccordionIconOptions {
  open: IconTypes;
  closed: IconTypes;
}

interface OwnProps {
  className?: string;
  iconOptions?: AccordionIconOptions;
  children?: React.ReactNode;
  preExpanded?: string[];
  allowMultipleExpanded?: boolean;
  allowZeroExpanded?: boolean;
  onChange?(args: string[]): void;
}

type Props = OwnProps;

export interface AccordionItemButtonOptions {
  label: string;
  iconOptions?: AccordionIconOptions;
}

export interface AccordionItemProps {
  className?: string;
  buttonClassName?: string;
  buttonOptions: AccordionItemButtonOptions;
  children?: React.ReactNode;
  uuid?: string;
  headingProps?: HTMLAttributes<any>;
}

const AccordionItem: React.FC<AccordionItemProps> = ({
  className = '',
  buttonClassName = '',
  buttonOptions,
  uuid,
  children,
  headingProps,
}) => {
  const buttonOptionsWithDefault = {
    iconOptions: {
      open: IconTypes.ARROW_DOWN,
      closed: IconTypes.ARROW_NEXT,
    },
    ...buttonOptions,
  };

  const getIcon = (open: boolean | undefined) => {
    const icon = open
      ? buttonOptionsWithDefault.iconOptions.open
      : buttonOptionsWithDefault.iconOptions.closed;

    return <Icon type={icon} />;
  };

  return (
    <ReactAccordionItem className={`AccordionItem Accordion__item ${className}`} uuid={uuid}>
      <AccordionItemHeading {...headingProps}>
        <AccordionItemButton className="Accordion__button">
          <AccordionItemState>{(state) => getIcon(state.expanded)}</AccordionItemState>
          <span className={`Accordion__button-label ${buttonClassName}`}>
            {buttonOptions.label}
          </span>
        </AccordionItemButton>
      </AccordionItemHeading>

      <AccordionItemPanel className="Accordion__panel">{children}</AccordionItemPanel>
    </ReactAccordionItem>
  );
};

const Accordion: React.FC<Props> = (props) => {
  const { className = '', children, ...rest } = props;
  return (
    <ReactAccordion className={`Accordion ${className}`} {...rest}>
      {children}
    </ReactAccordion>
  );
};
export { Accordion, AccordionItem };
